<template>
	<div>
		<v-text-field
			v-model="table.label"
			label="Nazwa tabeli"
			required
			aria-label="table name"
		/>
		
		<v-text-field
			v-model="table.hint"
			label="Opis tabeli"
			aria-label="table description"
		/>
		
		<v-text-field
			v-model.number="table.maxRows"
			type="number"
			label="Maksymalna liczba wierszy (0 = bez limitu)"
			min="0"
			aria-label="max rows"
		/>
		
		<v-divider class="my-4"/>
		
		<h4>Kolumny tabeli</h4>
		
		<div v-for="(column, index) in table.columns" :key="index" class="column-item">
			<v-layout row>
				<v-flex xs8>
					<v-text-field
						v-model="column.title"
						:label="'Tytuł kolumny ' + (index + 1)"
						required
					/>
				</v-flex>
				<v-flex xs4 class="text-xs-center">
					<v-btn 
						icon 
						@click="removeColumn(index)"
						:disabled="table.columns.length <= 1"
						class="delete-btn"
					>
						<v-icon color="red">delete</v-icon>
					</v-btn>
				</v-flex>
			</v-layout>
		</div>
		
		<v-btn 
			color="primary" 
			@click="addColumn"
			:disabled="table.columns.length >= 10"
		>
			Dodaj kolumnę
		</v-btn>
		
		<div class="mt-4">
			<small>Maksymalnie 10 kolumn. Minimum 1 kolumna wymagana.</small>
		</div>
		
		<v-divider class="my-4"/>
		
		<v-checkbox v-model="table.required" :label="`Wymagane`" aria-label="mandatory"></v-checkbox>
		<v-checkbox v-model="table.view" :label="`Wyświetlanie na podglądzie`"
			aria-label="show on print view"></v-checkbox>
	</div>
</template>

<script>
	export default {
		name: "TableFieldProps",
		
		props: {
			value: {
				type: Object,
				default: () => ({
					label: '',
					hint: '',
					maxRows: 0,
					columns: [{ title: 'Kolumna 1' }],
					required: false,
					view: true
				})
			}
		},
		
		computed: {
			table: {
				get() {
					return this.value;
				},
				set(val) {
					this.$emit('input', val);
				}
			}
		},
		
		methods: {
			addColumn() {
				if (this.table.columns.length < 10) {
					this.table.columns.push({ 
						title: `Kolumna ${this.table.columns.length + 1}` 
					});
				}
			},
			
			removeColumn(index) {
				if (this.table.columns.length > 1) {
					this.table.columns.splice(index, 1);
				}
			}
		}
	};
</script>

<style scoped>
	.column-item {
		margin-bottom: 10px;
		padding: 10px;
		border: 1px solid #e0e0e0;
		border-radius: 4px;
	}
	
	.delete-btn {
		background-color: white !important;
	}
	
	.delete-btn:hover {
		background-color: #ffebee !important;
	}
</style>